import useDevice from '@/hooks/useDevice';
import { useEffect } from 'react';
const useRemoveBodyScroll = open => {
  const {
    isMobile,
    isSafari,
    isiPhone,
    isFirefox
  } = useDevice();
  useEffect(() => {
    const restoreBodyScroll = () => {
      document.body.classList.remove('no-scroll-body');
      document.body.style.overflow = 'visible';
      if (!isMobile && !isSafari && !isiPhone) {
        document.body.style.paddingRight = '0';
      }
    };
    if (!open) {
      restoreBodyScroll();
      return restoreBodyScroll;
    }
    const timeoutId = setTimeout(() => {
      document.body.classList.add('no-scroll-body');
      document.body.style.overflow = 'hidden';
      if (!isMobile && !isSafari && !isiPhone && !isFirefox) {
        document.body.style.paddingRight = '10px';
      }
    }, 0);
    return () => {
      clearTimeout(timeoutId);
      restoreBodyScroll();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
};
export default useRemoveBodyScroll;